import { Model } from '@vuex-orm/core'

export class UserCourse extends Model {
  static entity = 'userCourse'
  static primaryKey = ['user_id', 'course_id']

  static fields () {
    return {
      user_id: this.attr(null),
      course_id: this.attr(null),
      state: this.attr(null),
      created_at: this.attr(null)

    }
  }
}

export default UserCourse
